export default __webpack_public_path__ + "static/chart_saves_time-62320c28317dc13548a96e9971647ac3.svg";